<!-- Button che serve a prevenire ad aprire la lista dei prefissi quando si preme enter nel form, mettendo questo
placeholder infatti l'enter viene "assorbito" da questo pulsante nascosto -->
<button style="display: none"></button>
<!-- Non cancellare questo button -->

<div class="flex flex-column flex-1">
  <div class="ios-phone-input" [class.large]="true">
    <label for="phoneNumber" [iosRequired]="isRequired" class="block mb-1 text-color-secondary">
      {{ 'LABEL.PHONE_NUMBER' | translate }}
    </label>
    <input
      id="phoneNumber"
      pInputText
      type="text"
      numeric
      [formControl]="phoneNumber"
      class="w-full custom-search-input"
      [class.ng-invalid]="isInvalid.error"
      [class.ng-dirty]="isInvalid.error"
      (focus)="onTouched()"
    />
    <button tabindex="-1" [disabled]="isDisabled" pButton (click)="prefixList.toggle($event)">
      <div class="flex align-content-center w-full">
        <span class="fi fi-{{ selectedPhonePrefix?.code | lowercase }}"></span>
        <span class="mx-1">{{ selectedPhonePrefix?.value }}</span>
        <i class="fa-solid fa-chevron-down ml-auto" style="padding-top: '0.15rem'"></i>
      </div>
    </button>
  </div>
  <small *ngIf="isInvalid.warning" [class.ios-input-warning]="isInvalid.warning" id="phoneNumber-help" class="block mt-1">
    {{ 'ERR.INVALID_PHONE_NUMBER' | translate }}
  </small>
</div>

<p-overlayPanel [focusOnShow]="false" styleClass="ios-prefix-menu-list" #prefixList (onShow)="onToggle(1)" (onHide)="onToggle(0)">
  <ng-template pTemplate>
    <span class="p-input-icon-left search">
      <i class="fa fa-search"></i>
      <input #searchInput type="text" pInputText placeholder="{{ 'LABEL.SEARCH' | translate }}" [formControl]="search" />
    </span>
    <div class="prefixes-list">
      <div
        *ngFor="
          let prefix of search.value == ''
            ? (phonePrefixes | cacheValues : selectedPhonePrefixBak?.phonePrefixId)
            : (filteredPrefixes | cacheValues : selectedPhonePrefixBak?.phonePrefixId)
        "
        class="prefix-element"
        (click)="changeSelectedPrefix(prefix); prefixList.toggle($event)"
      >
        <span class="mr-1 fi fi-{{ prefix?.code | lowercase }}"></span>
        <span>{{ prefix?.value }}</span>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>
